/**
 * 此处用于处理route中的参数
 * @param {*} route
 *
 * 后端及前端均需处理
 * 后端配置位在：router.js（nuxt 中间件机制）
 * 前端配置位在：mixin-async-data.js
 */

export const handleRoute = (route) => {
  if (route.params) {
    // 过滤route的参数，去除.html
    Object.keys(route.params).forEach((key) => {
      if (route.params[key]) {
        // 找到最后的.html
        const idx = route.params[key].lastIndexOf('.html');
        route.params[key] =
          idx === -1 ? route.params[key] : route.params[key].slice(0, idx);
      }
    });
  }

  return route.params;
};

/**
 * 判断是否移动端
 * @param {*} req
 */
function isMobile(req) {
  if (!req || !req.headers) return false;

  const { headers } = req;

  if (headers['via'] && headers['via'].includes('wap')) {
    return true;
  } else if (
    headers['accept'] &&
    headers['accept'].toUpperCase().includes('VND.WAP.WML')
  ) {
    return true;
  } else if (headers['x-wap-profile'] || headers['profile']) {
    return true;
  } else if (
    headers['user-agent'] &&
    /(blackberry|configuration\/cldc|hp |hp-|htc |htc_|htc-|iemobile|kindle|midp|mmp|motorola|mobile|nokia|opera mini|opera |Googlebot-Mobile|YahooSeeker\/M1A1-R2D2|android|iphone|ipod|mobi|palm|palmos|pocket|portalmmm|ppc;|smartphone|sonyericsson|sqh|spv|symbian|treo|up.browser|up.link|vodafone|windows ce|xda |xda_)/i.test(
      headers['user-agent']
    )
  ) {
    return true;
  }

  return false;
}

export default function ({ req, redirect, route }) {
  try {
    // 移动端访问自动跳转链接
    if (isMobile(req)) {
      let url = route.fullPath;
      url = url.replace(/\/learning\//g, '/mlearning/');
      url = url.replace(/\/course\//g, '/tutorial/');
      if (!url.includes('/mlearning/')) {
        url = `/mlearning${url}`;
      }
      redirect(`https://www.wps.cn${encodeURI(url)}`);
      return;
    }

    if(route.path.includes('/learning/tutorial_mobile/')){
      redirect(route.path.replace(/\/tutorial_mobile\//g, '/course/'));
      return;
    }

    handleRoute(route);
  } catch (e) {
    // 捕捉route层错误
    console.error('route-handler', e);
    redirect('https://www.wps.cn/learning');
  }
}
